import React from 'react';
import pouchHome from '../assets/pouch-home.png';



const Slide1 = (props) => {
    return (
        <>
        <div className='slide1-main'>
            <div className='slide1-outer'>
                <div className='slide1-box'>
                    <div className='slide1-textbox'>
                        <div className='slide1-title'>
                            Receive
                        </div>
                        <div className='slide1-description'>
                            Dine at your favourite local cafes and restaurants
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='slide1-image-box'>
                <img src={pouchHome} style={{height: "80%"}} alt="Image1"/>
            </div>
            
        </div>

        <style jsx>{`
                .slide1-main {
                    display: flex;
                    width: 1000px;
                    flex-direction: row;
                    align-items: center;
                    position: absolute;
                    opacity: ${props.active ? 1 : 0};
                    transition: opacity 0.5s ease-in;
                }
                .slide1-outer {
                    // display: flex;
                    flex-direction: column;
                }
                .slide1-box {
                    display: flex;
                    flex-direction: row;
                    height: 250px;
                    width: 1100px;
                    border-radius: 200px;
                    color: white;
                    background-color: ${props.color};
                    justify-content: center;
                    align-items: center;    
                }
                .slide1-textbox {
                    padding-top: 50px;
                    padding-bottom: 50px;
                    padding-left: 120px;
                    padding-right: 300px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                .slide1-title {
                    font-weight: 600;
                    font-size: 48px;
                    color: #fffefb;
                    margin-bottom: 10px;
                }
                .slide1-description {
                    font-size: 36px;
                    color: #fffefb;
                }
                .slide1-image-box {
                    transform: translateX(-300px);
                    width: 450px;
                    height: 600px;
                    z-index: 1;
                }
            `}</style>
        </>
    )
}

export default Slide1;